export var MARKETING_LAYOUT_TITLE = 'marketingLayout-title';
export var MARKETING_LAYOUT_DESCRIPTION = 'marketingLayout-description';